module.exports = __webpack_public_path__ + "static/media/n_icon_tab.85c15921.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_tab.png
// module id = 1815
// module chunks = 0 1